import * as React from 'react'

export type SidebarContextProps = {
  state: 'expanded' | 'collapsed'
  open: boolean
  setOpen: (open: boolean) => void
  openMobile: boolean
  setOpenMobile: (open: boolean) => void
  isMobile: boolean
  toggleSidebar: () => void
  /**
   * Opts into the rail-at-every-width behaviour: no mobile sheet, and an
   * expanded sidebar overlays sibling content below the breakpoint instead of
   * insetting it. Published here because `toggleSidebar` and the width both
   * live in the provider, so a prop on `Sidebar` alone could not reach them.
   */
  responsiveOverlay: boolean
}

export const SidebarContext = React.createContext<SidebarContextProps | null>(
  null
)

export function useSidebar() {
  const context = React.useContext(SidebarContext)
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider.')
  }

  return context
}
